module.exports = __webpack_public_path__ + "static/media/exit.939edb88.png";